export default class Recebivel {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.bancoId = 0;
        this.planoContaId = 0;
        this.planoContaItemId = 0;
        this.projetoId = 0;
        this.atividadeId = null;
        this.atividadeItemId = null;
        this.doadorId = 0;
        this.descricao = '';
        this.situacao = 'A';
        this.dataLancamento = new Date().yyyymmdd();
        this.dataEmissao = new Date().yyyymmdd();
        this.dataCompetencia = new Date().yyyymmdd();
        this.dataVencimento = null;
        this.dataPagamento = null;
        this.valor = 0;
        this.desconto = 0;
        this.juros = 0;
        this.valorFinal = 0;
        this.formaPagamento = 0;
        this.observacao = '';
        this.enviado = false;
        this.dataGeracaoRemessa = null;
        this.isRemessaGerada = false;

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.bancoId = model.bancoId; 
        this.banco = model.banco; 
        this.planoContaId = model.planoContaId;
        this.planoContaItemId = model.planoContaItemId;
        this.projetoId = model.projetoId;
        this.projeto = model.projeto;
        this.atividadeId = model.atividadeId;
        this.atividadeItemId = model.atividadeItemId;
        this.doadorId = model.doadorId;
        this.doador = model.doador;
        this.descricao = model.descricao;
        // this.dataLacamento = model.dataLacamento;
        // this.dataVencimento = model.dataVencimento;
        // this.dataPagamento = model.dataPagamento;
        this.dataLancamento = new Date(model.dataLancamento).yyyymmdd();
        this.dataVencimento = new Date(model.dataVencimento).yyyymmdd();
        this.dataCompetencia = model.dataCompetencia ? new Date(model.dataCompetencia).yyyymmdd() : null;
        this.dataPagamento = model.dataPagamento ? new Date(model.dataPagamento).yyyymmdd() : null;
        this.dataEmissao = new Date(model.dataEmissao).yyyymmdd();
        this.valor = model.valor;
        this.desconto = model.desconto;
        this.juros = model.juros;
        this.valorFinal = model.valorFinal;
        this.formaPagamento = model.formaPagamento;
        this.observacao = model.observacao;
        this.enviado = model.enviado;
        this.dataGeracaoRemessa = model.dataGeracaoRemessa;
        this.isRemessaGerada = model.isRemessaGerada;
    }
}